import { useCallback, useContext, useEffect, useState } from 'react';

import { GraphQLOperationFailed } from '../adapter/GraphQLClient';
import { SingleOfferFragment } from '../graphql/generated/graphql_offer';
import { context as DependencyContext } from '../view/context/dependency';

export const useGetOfferQuery = (offerId: string | undefined) => {
  const dependency = useContext(DependencyContext);

  const [res, setRes] = useState<NonNullable<SingleOfferFragment>>();
  const [loading, setLoading] = useState(0);
  const fetchData = useCallback(
    async (offerId: string) => {
      try {
        setLoading((loading) => ++loading);
        const res = await dependency.offer.offerWebApi.getById(offerId);
        setRes(res);
        setLoading((loading) => --loading);
      } catch (err) {
        const error = err as GraphQLOperationFailed;
        if (error.type === 'UnauthorizedError') {
          dependency.errorPresenter.showAsNonFatal(new Error('show_creation_page.unauthorized'));
        } else {
          throw err;
        }
      }
    },
    [dependency.offer.offerWebApi, dependency.errorPresenter],
  );

  useEffect(() => {
    if (offerId) {
      fetchData(offerId);
    }
  }, [fetchData, offerId]);

  return { offer: res, loading: loading > 0 };
};
